module.exports = __webpack_public_path__ + "static/media/Army_C.3820567a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Army_C.svg
// module id = 297
// module chunks = 0